import { VFC } from 'react'
import { FACEBOOK } from 'src/assets/images'
import { LoginUser, LoginUserProfile } from 'src/models/User'
import { getBirthYears } from 'src/utils/data'
import { ProfileEditorWrapper } from '../ProfileLayout'
import {
  FormImage,
  FormInput,
  FormInputMultiple,
  FormSelect,
  MasterDataSelect,
  ProfileForm,
} from '../formComponents'

type UserProfileFormProps = {
  user: LoginUser
  submit: (profile: LoginUserProfile) => Promise<any>
}

export const UserProfileForm: VFC<UserProfileFormProps> = ({
  user,
  submit,
}) => (
  <ProfileEditorWrapper user={user}>
    <ProfileForm
      title="プロフィールの変更"
      user={user}
      propertyKey="profile"
      submit={submit}
      isProfile
    >
      <FormImage id="iconSrc" label="プロフィール画像" optional />
      <FormInput id="name" label="お名前" placeholder="例:平野哲也" />
      <FormInput
        id="nameRuby"
        label="お名前（ふりがな）"
        placeholder="例:ひらのてつや"
        optional
      />
      <FormInput
        id="email"
        label="メールアドレス"
        placeholder="例:info:onlystory.jp"
        type="mail"
      />
      <FormInputMultiple
        id="emailCc"
        label="その他のメールアドレス"
        placeholder="例:info:onlystory.jp"
        description="※こちらのメールアドレスは、通知メールをお送りするとき、CCに指定されます。"
        max={7}
        type="mail"
        optional
      />
      <FormInput
        id="fbUrl"
        label="FacebookURL"
        placeholder="例:https://www.facebook.com/"
        icon={FACEBOOK}
        type="link"
        optional
      />
      <FormInput
        id="phoneNumber"
        label="電話番号"
        placeholder="例:090-6869-5869"
        type="phone"
        optional
      />
      <FormSelect id="birthYear" label="誕生年" options={getBirthYears()} />
      <MasterDataSelect type="positions" id="position" label="役職" />
    </ProfileForm>
  </ProfileEditorWrapper>
)
